import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import api from '@/api/finance';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async getTradeLogs(params: any) {
    return api.getTradeLogs(params);
  }

  @Action
  async exportTradeLogs(params: any) {
    return api.exportTradeLogs(params);
  }

  @Action
  async newTradeLogsList(params: any) {
    return api.newTradeLogsList(params);
  }

  @Action
  async newExportTradeLogsList(params: any) {
    return api.newExportTradeLogsList(params);
  }

  @Action
  async getSettlements(params: any) {
    return api.getSettlements(params);
  }
  @Action
  async errorCorrectionList(params: any) {
    return api.errorCorrectionList(params);
  }
   @Action
  async errorCorrectionItems(params: any){
  	return api.errorCorrectionItems(params);
  } 
	@Action
  async errorCorrectionAddlog(params: any){
  	return api.errorCorrectionAddlog(params);
  }
  @Action
  async errorCorrectionDetail(params: any){
  	return api.errorCorrectionDetail(params);
  }
  @Action
  async getProfitSettlements(params: any) {
    return api.getProfitSettlements(params);
  }

  @Action
  async compareProfitSettlement(params: any) {
    return api.compareProfitSettlement(params);
  }

  @Action
  async getSettlementDetail(params: any) {
    return api.getSettlementDetail(params);
  }

  @Action
  async getSettlementDetail1(params: any) {
    return api.getSettlementDetail1(params);
  }

  @Action
  async getSettlementItems(params: any) {
    return api.getSettlementItems(params);
  }

  @Action
  async exportSettlements(params: any) {
    return api.exportSettlements(params);
  }

  @Action
  async audit(params: any) {
    return api.audit(params);
  }

  @Action
  async auditNormal(params: any) {
    return api.auditNormal(params);
  }

  @Action
  async statistics(params: any) {
    return api.statistics(params);
  }

  @Action
  async getReconciliations(params: any) {
    return api.getReconciliations(params);
  }

  @Action
  async getReconciliactionDetail(params: any) {
    return api.getReconciliactionDetail(params);
  }

  @Action
  async checkAllUser(params: any) {
    return api.checkAllUser(params);
  }

  @Action
  async checkByUser(params: any) {
    return api.checkByUser(params);
  }

  @Action
  async handleInvoice(params: any) {
    return api.handleInvoice(params);
  }

  @Action
  async uploadInvoice(params: any) {
    return api.uploadInvoice(params);
  }

  @Action
  async addRemark(params: any) {
    return api.addRemark(params);
  }

  @Action
  async downTradeBill(params: any) {
    return api.downTradeBill(params);
  }

  @Action
  async process(params: any) {
    return api.process(params);
  }

  @Action
  async reNoticeProcess(params: any) {
    return api.reNoticeProcess(params);
  }

  @Action
  async balance(params: any) {
    return api.balance(params);
  }

  @Action
  async alipaytransfer(params: any) {
    return api.alipaytransfer(params);
  }

  @Action
  async exportBill(params: any) {
    return api.exportBill(params);
  }
}
